import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import OncallContainer from './OncallContainer'


const OncallRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><OncallContainer></OncallContainer></Provider>
}

OncallRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default OncallRoot
